<template>
  <v-dialog v-model="dialogActive" width="25%" persistent>
    <v-card class="py-4 px-5">
      <v-card-text class="title pa-4">{{ message }}</v-card-text>

      <v-divider class="primary"></v-divider>

      <v-card-actions class="pt-4 px-0">
        <div class="flex-grow-1"></div>
        <v-btn
          data-cy="proceed"
          class="primary"
          dark
          text
          @click="
            isActive = false;
            $emit('proceed');
          "
          >Yes</v-btn
        >
        <v-btn
          data-cy="cancel"
          class="primary"
          dark
          text
          @click="
            isActive = false;
            $emit('cancel');
          "
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AppDialog",
  props: {
    disable: { type: Boolean },
    buttonText: { type: String },
    message: { type: String, required: true },
    dialogActive: { type: Boolean },
  },
};
</script>
